import { buildSharedConfig, type SharedInitOptions } from './shared';
import { createWebI18nFromConfig } from './web-runtime';

/** Full shared resources remain the default for portal and admin. */
export function createWebI18n(opts: SharedInitOptions) {
  return createWebI18nFromConfig(buildSharedConfig(opts), opts.initialLocale);
}
